import { LoaderFunctionArgs } from 'react-router-dom'
import { getThemeSettings } from '../api/getThemeSettings'
import { applyTheme, hasTheme } from '../utils/theme'

const loaderMock = async () => ({})

type OptionalLoader<T = any> = (
    args: LoaderFunctionArgs,
    paymentPageId: string,
) => Promise<T>

export const withTheme = <T = any>(
    loader?: OptionalLoader<T>,
) => {
    return async (args: LoaderFunctionArgs) => {
        const { paymentPageId } = args.params

        if (!paymentPageId) {
            throw new Response('Payment page ID is required', { status: 400 })
        }

        if (!hasTheme()) {
            const [themeResult, dataResult] = await Promise.allSettled([
                getThemeSettings(paymentPageId),
                (loader || loaderMock)(args, paymentPageId),
            ])

            if (themeResult.status === 'fulfilled') {
                applyTheme(themeResult.value)
            } else {
                console.error('Failed to load theme:', themeResult.reason)
            }

            if (dataResult.status === 'rejected') {
                throw dataResult.reason
            }

            return dataResult.value
        }

        return await (loader || loaderMock)(args, paymentPageId)
    }
}
